<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeContratReconductible.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeContratReconductible.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto is-marginless" :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12">
          <b-field :label="$t('listeContratReconductible.filtre.periode')">
            <div class="columns is-vcentered" >
              <b-datepicker show-week-number
                            class="column"
                            icon="calendar-today"
                            :editable="true"
                            v-model="dates.dateDebut"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
              <span class="column is-1">{{$t('listeContratReconductible.filtre.au')}}</span>
              <b-datepicker show-week-number
                            class="column"
                            icon="calendar-today"
                            :editable="true"
                            v-model="dates.dateFin"
                            position="is-bottom-left"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </div>          </b-field>
        </div>
        <div class="column is-12">
          <b-field :label="$t('listeContratReconductible.filtre.parDateDe')">
            <b-select v-model="filteredByDates" expanded>
              <option :value="null"></option>
              <option
                v-for="item in filtreByDate"
                :key="item.key"
                :value="item.key">
                {{ $t(item.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeContratReconductible.filtre.codeFace')">
            <qd-taginput
              v-model="newCritereRecherche.codesFace"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field :label="$t('listeContratReconductible.filtre.natureContrat')">
            <qd-taginput
              v-if="natureTags"
              v-model="natureSelected"
              :data="natureTags"
              @typing="getFilteredNatureTags"
              @input="getNatureTag"
              type="is-primary"
              icon="magnify"
              field="libelle"
              autocomplete
              open-on-focus>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12">
          <libelle-tag-input
                      :label="$t('listeContratReconductible.filtre.typeContrat')"
                      :items="constantes.LISTE_TYPE_CONTRAT"
                      v-model="typeContratSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12">
          <libelle-tag-input
                      :label="$t('listeContratReconductible.filtre.termePaiementContrat')"
                      :items="constantes.LISTE_TERME_PAIEMENT"
                      v-model="termePaiementSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12">
          <libelle-tag-input
                      :label="$t('listeContratReconductible.filtre.etatContrat')"
                      :items="constantes.LISTE_ETAT_CONTRAT"
                      v-model="etatContratSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12">
          <b-field :label="$t('listeContratReconductible.filtre.tacite')">
            <b-select v-model="newCritereRecherche.tacite">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="agencesSelectionnees.length > 1">
          <agence-tag-input
                      :label="$t('listeDevis.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeContratReconductible.filtre.actions.appliquer')}}</button>

      <button @click="viderCritere()"
        class="button border-none mgt-10px has-text-icon-more pd-10px"
      >{{$t('listeContratReconductible.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheContratReconductible from '@/services/baux/contrat/genererCritereRechercheContratReconductible';
import {
  LISTE_TERME_PAIEMENT,
  LISTE_TYPE_CONTRAT,
  LISTE_ETAT_CONTRAT,
  TYPE_FILTRE_DATE_ECHEANCE,
  TYPE_FILTRE_DATE_PREAVIS,
} from '@/configuration/baux/contrat/contratConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationFiltreContratReconductible
  from '@/services/baux/contrat/reconductible/validationFiltreContratReconductible';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
  },
  components: {
    agenceTagInput,
    libelleTagInput,
    errorMsgComponent,
  },
  data() {
    return {
      hasError: false,
      errors: [],
      natureTags: null,
      listeNatureBase: [],
      natureSelected: [],
      newCritereRecherche: null,
      constantes: {
        LISTE_TYPE_CONTRAT,
        LISTE_TERME_PAIEMENT,
        LISTE_ETAT_CONTRAT,
      },
      filteredByDates: null,
      filtreByDate: [
        { key: 'dateFinEcheance', libelle: 'listeContratReconductible.filtre.filtreParDate.dateFinEcheanceContrat' },
        { key: 'datePreavis', libelle: 'listeContratReconductible.filtre.filtreParDate.datePreavis' },
      ],
      dates: {
        dateDebut: null,
        dateFin: null,
      },
      termePaiementSelected: [],
      typeContratSelected: [],
      etatContratSelected: [],
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    viderCritere() {
      this.newCritereRecherche = cloneDeep(genererCritereRechercheContratReconductible());
      this.setDateInformation(this.newCritereRecherche);
      this.termePaiementSelected = [];
      this.etatContratSelected = this.constantes.LISTE_ETAT_CONTRAT.filter((c) => {
        return this.newCritereRecherche.etat.includes(c.code);
      });
      this.termePaiementSelected = [];
      this.natureSelected = [];
      this.typeContratSelected = [];
      this.getNatureTag();
    },
    setFilteredDates() {
      const copyDate = cloneDeep(this.dates);
      copyDate.dateDebut = formatIsoDate(copyDate.dateDebut);
      copyDate.dateFin = formatIsoDate(copyDate.dateFin);
      switch (this.filteredByDates) {
        case TYPE_FILTRE_DATE_ECHEANCE:
          this.newCritereRecherche.dateFinEcheance = copyDate;
          this.newCritereRecherche.datePreavis = null;
          break;
        case TYPE_FILTRE_DATE_PREAVIS:
          this.newCritereRecherche.datePreavis = copyDate;
          this.newCritereRecherche.dateFinEcheance = null;
          break;
        default:
          this.newCritereRecherche.dateFinEcheance = null;
          this.newCritereRecherche.datePreavis = null;
          break;
      }
      this.errors = [];
      this.hasError = validationFiltreContratReconductible(
        this.filteredByDates,
        this.dates,
        this.errors,
      );
      return this.hasError;
    },
    appliquerCritere() {
      const error = this.setFilteredDates();
      if (error) return;
      this.newCritereRecherche.naturesId = this.natureSelected.map(el => { return el.id; });
      this.newCritereRecherche.termePaiement = this.termePaiementSelected.map(el => {
        return el.code;
      });
      this.newCritereRecherche.contratType = this.typeContratSelected.map(el => {
        return el.code;
      });
      this.newCritereRecherche.etat = this.etatContratSelected.map(el => { return el.code; });
      this.$emit('recherche', this.newCritereRecherche);
    },
    getFilteredNatureTags(text) {
      this.getNatureTag();
      this.natureTags = this.natureTags.filter((nature) => {
        return nature.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getNatureTag() {
      this.natureTags = this.listeNatureBase.filter((nature) => {
        return !this.natureSelected.map(a => a.id).includes(nature.id);
      });
    },
    setDateInformation(newCritereRecherche) {
      if (newCritereRecherche.datePreavis) {
        this.dates.dateFin = new Date(newCritereRecherche.datePreavis.dateFin);
        this.dates.dateDebut = new Date(newCritereRecherche.datePreavis.dateDebut);
        this.filteredByDates = TYPE_FILTRE_DATE_PREAVIS;
      }

      if (newCritereRecherche.dateFinEcheance) {
        this.dates.dateFin = new Date(newCritereRecherche.dateFinEcheance.dateFin);
        this.dates.dateDebut = new Date(newCritereRecherche.dateFinEcheance.dateDebut);
        this.filteredByDates = TYPE_FILTRE_DATE_ECHEANCE;
      }
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      const newCritereRecherche = cloneDeep(this.critereRecherche);
      try {
        await this.loadParametres([
          typesParametres.PARAMETRES_KEYS.contratNature,
        ]);
        this.setDateInformation(newCritereRecherche);

        this.newCritereRecherche = newCritereRecherche;

        this.listeNatureBase = this.contratNature;
        if (this.newCritereRecherche.naturesId) {
          this.natureSelected = this.listeNatureBase.filter((c) => {
            return this.newCritereRecherche.naturesId.includes(c.id);
          });
        }
        this.getNatureTag();

        if (this.newCritereRecherche.termePaiement) {
          this.termePaiementSelected = this.constantes.LISTE_TERME_PAIEMENT.filter((c) => {
            return this.newCritereRecherche.termePaiement.includes(c.code);
          });
        }

        if (this.newCritereRecherche.contratType.length > 0) {
          this.typeContratSelected = this.constantes.LISTE_TYPE_CONTRAT.filter((c) => {
            return this.newCritereRecherche.contratType.includes(c.code);
          });
        }

        if (this.newCritereRecherche.etat) {
          this.etatContratSelected = this.constantes.LISTE_ETAT_CONTRAT.filter((c) => {
            return this.newCritereRecherche.etat.includes(c.code);
          });
        }

        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    contratNature() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.contratNature);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
